<ng-container *ngIf="selectedPlanData$ | async as planData">
  <ul *ngIf="planData.menuFeatList" [ngClass]="{ open: isMenuOpen }">
    <li class="first" *ngIf="planData.registration">
      <app-expansion-panel
        [title]="menuItemTitleEnum.MANAGE_PLANS"
        [registration]="planData.registration"
        [features]="
          mountMenuGroup(menuGroups.MANAGE_PLANS, planData.menuFeatList)
        "
        [fourColums]="true"
      ></app-expansion-panel>
    </li>
    <li
      class="second"
      *ngIf="
        planData.registration &&
        hasFeatOn(feature.EXTRA_CONTRIBUTION, planData.cardsFeatList)
      "
    >
      <button
        mat-flat-button
        (click)="
          handleNavigationItemAction(
            feature.EXTRA_CONTRIBUTION,
            planData.registration
          )
        "
        *ngIf="hasFeatOn(feature.EXTRA_CONTRIBUTION, planData.menuFeatList)"
      >
        {{ menuItemTitleEnum.EXTRA_CONTRIBUTION }}
      </button>
    </li>
    <li class="third" *ngIf="!!planData?.menuFeatList.length">
      <app-expansion-panel
        [title]="menuItemTitleEnum.OTHER_FEATURES"
        [registration]="planData.registration"
        [features]="
          mountMenuGroup(menuGroups.OTHER_FEATURES, planData.menuFeatList)
        "
      ></app-expansion-panel>
    </li>
    <li class="fourth">
      <button mat-flat-button (click)="navigateTo('/support')">
        {{ menuItemTitleEnum.SUPPORT }}
      </button>
    </li>
  </ul>
</ng-container>
